import React from "react";
import Headers from "./Headers";
import TablePagination from "components/Pagination/TablePagination";
import StudyGroupsItem from "./StudyGroupsItem";

const StudyGroupsList = ({
  studygroups,
  checkedStudygroupIds,
  studygroup_ids,
  paginationProps,
  onOrderChange,
  query,
}) => {
  return (
    <table>
      <Headers />
      {studygroups.map((group) => (
        <StudyGroupsItem
          key={group.id}
          group={group}
          checkedStudygroupIds={checkedStudygroupIds}
          studygroup_ids={studygroup_ids}
        />
      ))}
      <tr>
        <td colSpan="9">
          <TablePagination {...paginationProps} />
        </td>
      </tr>
    </table>
  );
};

export default StudyGroupsList;

// import React from 'react';
// import StudyGroupsItem from './StudyGroupsItem';

// const StudyGroupsList = ({ group }) => {
//     return (
//         <div>
//             {group.map(group => <StudyGroupsItem key={group.id} group={group} />)}
//         </div>
//     )
// }

// export default StudyGroupsList;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/List/StudyGroupsList.jsx